'use strict';

import Notification from '../components/notification';
import { newModalFromString } from '../components/modal';
var timeoutFeedbackWishlist = null;
/**
 * Adapts FE to the current state of the wishlist:
 *  - Add / Remove the `added` class to the correct target (either button or icon)
 *  - Shows the "correctly added" / "correctly removed" notification
 *  - Triggers ADD event for analytics
 *  - Add/remove the PID from the ID in page to always have the correct state
 *      (updateWishlistInternalState)
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to toggle a product to the wishlist
 * @param {boolean} isAddAction - if the te action was add or remove
 */

function displayMessageAndChangeIcon (data, icon, isAddAction, pid, wishlistView = true) {
    $.spinner().stop();
    const notification = new Notification();
    if (data.success) {
        $('body').trigger('wishlist:update', data.wishlistTotal);
        if (icon) {
            if (isAddAction) {
                // Support PDP button
                const availability = $(`.analytics[data-item_sfcc="${pid}"]`).data('item_availability');
                icon.addClass('added');
                if (icon.hasClass('button')) {
                    icon.removeClass('button-primary');
                    let sender = icon.parents('.product-quickview').length === 0 ? 'product_detail_page':'quick_view';
                    $('body').trigger('wishlist:add', { sku: data.pid, sender: sender, availability: availability });
                } else if (icon.hasClass('quickWishlist')) {
                    // Quick view
                    $('body').trigger('wishlist:add', { sku: data.pid, sender: 'quick_view', availability: availability });
                } else {
                    // PLP
                    let $container = icon.closest('.product-tile').length > 0 ? icon.closest('.product-tile') : icon.closest('.product');
                    $container.find('.wishlistTile').addClass('added');
                    $container.find('.comingSoonBox .add-to-wish-list-coming-soon').addClass('hidden');
                    $container.find('.soldoutBox .add-to-wish-list-coming-soon').addClass('hidden');
                    $('body').trigger('wishlist:add', { sku: data.pid, sender: 'listing', availability: availability, GTMParentItemId: data.GTMParentItemId, GTMParentItemCategory4: data.GTMParentItemCategory4 });
                }
                if (wishlistView) {
                    forceShowFeedbackCart(pid, true);
                }
            } else {
                // Support PDP button
                icon.removeClass('added');
                if (icon.hasClass('button')) {
                    icon.addClass('button-primary');
                    let sender = icon.parents('.product-quickview').length === 0 ? 'product_detail_page':'quick_view';
                    $('body').trigger('wishlist:remove', { sku: pid, sender: sender });
                } else if (icon.hasClass('quickWishlist')) {
                    icon.removeClass('added');
                    $('body').trigger('wishlist:remove', { sku: pid, sender: 'quick_view' });
                } else {
                    // PLP
                    let $container = icon.closest('.product-tile').length > 0 ? icon.closest('.product-tile') : icon.closest('.product');
                    $container.find('.wishlistTile').removeClass('added');
                    $container.find('.comingSoonBox .add-to-wish-list-coming-soon').removeClass('hidden');
                    $container.find('.soldoutBox .add-to-wish-list-coming-soon').removeClass('hidden');
                    $('body').trigger('wishlist:remove', { sku: pid, sender: 'listing' });
                }
                if (wishlistView) {
                    forceShowFeedbackCart(pid, false);
                }
            }
            icon.blur();
        }
        notification.setType('success');
        updateWishlistInternalState(data.pid, isAddAction);
    } else {
        notification.setType('danger');
    }
    notification.show();
    notification.timeout(5000);
}

/**
 * Updates the internal state of the wishlist with the new item:
 *  - adds the item in the state if the item was added
 *  - removes the item if the item was removed
 * @param {string} pid - The PID of the product changed in the wishlist
 * @param {boolean} isAddAction - true if the item has been added, false is it has been removed
 */
function updateWishlistInternalState (pid, isAddAction) {
    /** @type {Array.<string>} */
    let oldItems = $('#wishlistItems').data('wishlistitems').split(',');
    let newItems;
    if (isAddAction) {
        oldItems.push(pid);
        newItems = oldItems.join(',');
    } else {
        let oldIdx = oldItems.indexOf(pid);
        if (oldIdx > -1) {
            oldItems.splice(oldIdx, 1);
            newItems = oldItems.join(',');
        }
    }
    $('#wishlistItems').data('wishlistitems', newItems);
};
var timeoutFeedbackWishlist = null;
function forceShowFeedbackCart (pid, isAdd) {
    forceHideFeedbackCart();
    if (timeoutFeedbackWishlist != null) {
        clearTimeout(timeoutFeedbackWishlist);
        timeoutFeedbackWishlist = null;
    }
    let container = $('.wishlist-section');

    container.addClass('open');

    var url = $('.wishlist-section').data('show-wishlist-cart-url') + '?pid=' + decodeURIComponent(pid) + '&fromWishlist=true&isAdd=' + isAdd;
    if (container.find('.wishlist-popover.show').length === 0) {
        $.get(url, function (data) {
            container.find('.wishlist-popover').empty().append(data);
            let hadClass = $('.wishlist-section .wishlist-popover').hasClass('show');
            $('.wishlist-section .wishlist-popover').addClass('js-feedback-cart-popover');
            container.find('.wishlist-popover').addClass('show');
            $('.black-background').removeClass('hide');

            let startTimer = true;
            container.on('mouseenter focusin', (e) => {
                if (timeoutFeedbackWishlist != null) {
                    clearTimeout(timeoutFeedbackWishlist);
                    timeoutFeedbackWishlist = null;
                }
            });
            container.on('click', '.js_paypal_button', (e) => {
                startTimer = false;
                if (timeoutFeedbackWishlist != null) {
                    clearTimeout(timeoutFeedbackWishlist);
                    timeoutFeedbackWishlist = null;
                }
            });
            container.on('mouseleave', (e) => {
                if (!startTimer) {
                    return;
                }

                if (timeoutFeedbackWishlist != null) {
                    clearTimeout(timeoutFeedbackWishlist);
                    timeoutFeedbackWishlist = null;
                }
                timeoutFeedbackWishlist = setTimeout(() => {
                    forceHideFeedbackCart();
                }, 3000);
            });

            if (timeoutFeedbackWishlist != null) {
                clearTimeout(timeoutFeedbackWishlist);
                timeoutFeedbackWishlist = null;
            }
            timeoutFeedbackWishlist = setTimeout(() => {
                forceHideFeedbackCart();
            }, 3000);
            $(document).on('click touchstart', function (e) {
                var targetContainer = container.find('.wishlist-popover');
                if (!targetContainer.is(e.target) && targetContainer.has(e.target).length === 0) {
                    forceHideFeedbackCart();
                }
            });
            $('.js-feedback-close-button').on('click', function (e) {
                e.preventDefault();
                forceHideFeedbackCart();
            });
        });
    }
};

function forceHideFeedbackCart () {
    if (timeoutFeedbackWishlist != null) {
        clearTimeout(timeoutFeedbackWishlist);
        timeoutFeedbackWishlist = null;
    }
    $('.wishlist-section .wishlist-popover').removeClass('js-feedback-cart-popover');
    $('.wishlist-section .wishlist-popover').removeClass('show');
    $('.black-background').addClass('hide');
    $('.wishlist-section').removeClass('open');
};

module.exports = {

    showHide: function () {
        // $('.js-wishlist').on('mouseenter focusin', showWishlist)
        //    .on('mouseleave', hideWishlist);
    },

    checkItemInWishlist: function (itemCode) {
        return $('#wishlistItems').length > 0 && $('#wishlistItems').data('wishlistitems').split(',').indexOf(itemCode) > -1;
    },

    /**
     * Add the `added' class to the wishlist icon if the item is available in the wishlist.
     * It is not possible to do it in ISML because both the PDP and the PLP are cached
     *
     * Read the DOM element `#wishlistItems` and adds the `added` class to all the
     * `plp-wishlist` or `add-to-wish-list` items available in>
     *  - quickview
     *  - PDP
     *  - PLP
     */
    highlightIconsForAllItemsInWishlist: function () {
        if (!$('#wishlistItems').length) {
            return;
        }
        var itemsInWishlist = $('#wishlistItems').data('wishlistitems').split(',');
        for (var i = 0; i < itemsInWishlist.length; i++) {
            var itemCode = itemsInWishlist[i];
            $(`.product[data-pid="${itemCode}"] .plp-wishlist`).addClass('added');
            $(`.product[data-pid="${itemCode}"] .add-to-wish-list-coming-soon`).addClass('hidden');
            $(`.product-detail[data-pid="${itemCode}"] .add-to-wish-list`).addClass('added');
        }
    },

    /**
     * Adds the current item referenced by the current target to the wishlist
     * and updates the front-end
     */
    addToWishlist: function () {
        $('body').on('click', '.add-to-wish-list', function (e) {
            e.preventDefault();

            var btn = $(e.currentTarget);
            var addURL = btn.data('href');
            var removeURL = btn.data('remove');
            var pid = $('.product-detail-keeper').attr('data-variant-pid');
            var optionId = btn.closest('.product-detail-keeper').find('.product-option').attr('data-option-id');
            var optionVal = btn.closest('.product-detail-keeper').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;

            var shouldAdd = !btn.hasClass('added');

            if (!(addURL && removeURL) || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: shouldAdd ? addURL : removeURL,
                type: shouldAdd ? 'post' : 'get',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, btn, shouldAdd, pid);
                    $('body').trigger('wishlist:changedSuccessfully', { data: data, isAdding: shouldAdd, pid: pid });
                    let itemsOriginallyInWishlist = $('#wishlistItems').data('wishlistitems');
                    if (shouldAdd) {
                        $('#wishlistItems').data('wishlistItems', itemsOriginallyInWishlist + ',' + pid);
                    } else {
                        let newItemsInWishlist = [];
                        let itemsInWishlist = itemsOriginallyInWishlist.split(',');
                        for (var i = 0; i < itemsInWishlist.length; i++) {
                            if (itemsInWishlist[i] !== pid) {
                                newItemsInWishlist.push(itemsInWishlist[i]);
                            }
                        }
                        $('#wishlistItems').data('#wishlistItems', itemsInWishlist.join(','));
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, btn, shouldAdd, pid);
                }
            });
        }).on('click', '.wishlistTile, .add-to-wish-list-coming-soon, .wishlistTile-white', function (e) {
            e.preventDefault();
            var $btn = $(e.currentTarget);
            if ($(this).hasClass('add-to-wish-list-coming-soon')) {
                $btn = $(this).closest('.product-tile').find('.wishlistTile');
            }
            var icon = $btn.find('svg');
            var addURL = $btn.data('href');
            var removeURL = $btn.data('remove');
            var pid = $btn.closest('.product, .product-quickview, .product-info, .product-detail').data('pid');
            var optionId = $btn.closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $btn.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;

            var shouldAdd = !$btn.hasClass('added');
            if (!(addURL && removeURL) || !pid) {
                return;
            }

            var data = {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            };

            var $analyticsContainer = $(e.target).closest('.product').find('.analytics.productListingItem');
            if ($analyticsContainer.length && shouldAdd) {
                let parent_item_id = $analyticsContainer.data('parent_item_id');
                let parent_item_category4 = $analyticsContainer.data('parent_item_category4');
                if (parent_item_id && parent_item_category4) {
                    data.parent_item_id = parent_item_id;
                    data.parent_item_category4 = parent_item_category4;
                }
            }

            $.spinner().start();
            $.ajax({
                url: shouldAdd ? addURL : removeURL,
                type: shouldAdd ? 'post' : 'get',
                dataType: 'json',
                data: data,
                success: function (data) {
                    if (!shouldAdd) {
                        $btn.removeClass('added');
                    }
                    let vieWishilist = true;
                    if ($btn.hasClass('js-completeToPromoWishlist')) {
                        vieWishilist = false;
                    }
                    displayMessageAndChangeIcon(data, icon, shouldAdd, pid, vieWishilist);

                    $('body').trigger('wishlist:changedSuccessfully', { data: data, isAdding: shouldAdd, pid: pid });

                    let itemsOriginallyInWishlist = $('#wishlistItems').data('wishlistitems');
                    if (shouldAdd) {
                        $('#wishlistItems').data('#wishlistItems', itemsOriginallyInWishlist + ',' + pid);
                    } else {
                        let newItemsInWishlist = [];
                        let itemsInWishlist = itemsOriginallyInWishlist.split(',');
                        for (var i = 0; i < itemsInWishlist.length; i++) {
                            if (itemsInWishlist[i] !== pid) {
                                newItemsInWishlist.push(itemsInWishlist[i]);
                            }
                        }
                        $('#wishlistItems').data('#wishlistItems', itemsInWishlist.join(','));
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon, shouldAdd, pid);
                }
            });
        });
    },

    moveToWishlistHelper: function (e) {
        if (!e) {
            return;
        }
        e.preventDefault();

        var $btn = $(e.currentTarget);
        var url = $btn.data('href');
        var pid = $btn.data('pid');

        $.spinner().start();
        return $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: null,
                optionVal: null
            },
            success: function (data) {
                displayMessageAndChangeIcon(data, $btn, true, pid, false);
            },
            error: function (err) {
                displayMessageAndChangeIcon(err, null);
            }
        });
    }
};
